import ImageRenderer from '@/molecules/CustomMarkdown/components/ImageRenderer';
import ListRenderer from '@/molecules/CustomMarkdown/components/ListRenderer';
import StrongRenderer from '@/molecules/CustomMarkdown/components/StrongRenderer';
import {
  H1Renderer,
  H2Renderer,
  H3Renderer,
  H4Renderer,
  H5Renderer,
  H6Renderer,
} from '@/molecules/CustomMarkdown/components/Headings';
import HrRenderer from '@/molecules/CustomMarkdown/components/HrRenderer';
import LinkRenderer from '@/molecules/CustomMarkdown/components/LinkRenderer';
import ParagraphRenderer from '@/molecules/CustomMarkdown/components/ParagraphRenderer';
import BlockquoteRenderer from '@/molecules/CustomMarkdown/components/QuoteRenderer';
import {
  TableRenderer,
  TdRenderer,
  TheadRenderer,
  ThRenderer,
  TrRenderer,
} from '@/molecules/CustomMarkdown/components/Tables';
import { MDXComponents } from 'mdx/types';

const BrRenderer = () => <br />; // br ne marche pas =(

export const components: MDXComponents = {
  // headings
  h1: H1Renderer,
  h2: (props) => <H2Renderer {...props} className="my-4" />,
  h3: H3Renderer,
  h4: H4Renderer,
  h5: H5Renderer,
  h6: H6Renderer,
  // texts
  p: ParagraphRenderer,
  a: LinkRenderer,
  blockquote: BlockquoteRenderer,
  strong: StrongRenderer,
  hr: HrRenderer,
  // lists
  ul: (props) => <ListRenderer {...props} className="my-4" />,
  img: ImageRenderer,
  br: BrRenderer,
  // tables
  table: TableRenderer,
  tr: TrRenderer,
  th: ThRenderer,
  thead: TheadRenderer,
  td: TdRenderer,
};
